import { readContract } from '@wagmi/core';

import type { Address} from 'viem';
import { erc20Abi } from 'viem';

// eslint-disable-next-line deprecate/import
import { wagmiConfig } from '@shared/common/providers/LegacyWeb3Provider/wagmi';
import type { Web3Handle } from '@shared/helpers/web3/handle';

type GetTokenBalanceProps = Partial<Web3Handle> & {
  walletAddress?: Address;
};

export async function getTokenBalance(props?: GetTokenBalanceProps): Promise<bigint> {
  const { address, chainId, walletAddress } = props ?? {};

  return chainId && address && walletAddress
    ? await readContract(wagmiConfig, {
        abi: erc20Abi,
        address,
        functionName: 'balanceOf',
        args: [walletAddress],
        chainId,
      })
    : BigInt(0);
}
